import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";
import { defineAsyncComponent } from "vue";
import { useUserStore } from "@/stores/modules/user";
export const financingManagementRouter: RouteRecordRaw[] = [
    {
        path: "financing",
        name: "FinancingManagement",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/financing/customer",
        meta: {
            title: "融资管理"
        },
        children: [
            {
                path: "/financing/customer",
                name: "CustomerFinancing",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/customerFinancing/index.vue");
                    }
                }),
                meta: {
                    title: "客户融资",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/financing/customer/add",
                name: "CustomerFinancingAdd",
                component: () => import("@/views/pages/financingManagement/customerFinancing/add/index.vue"),
                meta: {
                    title: "新增融资",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "CustomerFinancing",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/financing/customer/edit/:id",
                name: "CustomerFinancingEdit",
                component: () => import("@/views/pages/financingManagement/customerFinancing/add/index.vue"),
                meta: {
                    title: "修改融资",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "CustomerFinancing",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/financing/customer/:id",
                name: "CustomerFinancingDetail",
                component: () => import("@/views/pages/financingManagement/customerFinancing/detail.vue"),
                meta: {
                    title: "融资详情",
                    // pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "CustomerFinancing",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ],
                    isNotShowHeader: true
                }
            },
            {
                path: "/financing/receiptForLoan",
                name: "ReceiptForLoan",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/receiptForLoan/index.vue");
                    }
                }),
                meta: {
                    title: "客户借据",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "/financing/refund",
                name: "FinancingRefund",
                component: defineAsyncComponent(() => {
                    const userStore = useUserStore();
                    if (userStore?.isSAAS) {
                        return import("@/views/components/emptyPage/index.vue");
                    } else {
                        return import("@/views/pages/financingManagement/financingRefund/index.vue");
                    }
                }),
                meta: {
                    title: "客户还款",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ]
                }
            },
            {
                path: "/financing/refund/:id",
                name: "RepaymentDetail",
                component: () => import("@/views/pages/financingManagement/financingRefund/detail.vue"),
                meta: {
                    title: "还款详情",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "FinancingRefund",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_PROJECT_ALL_R"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default financingManagementRouter;
